/**
 * Shared GSAP Library
 * One copy of gsap + ScrollTrigger for every component that animates on scroll,
 * mirroring lib/swiper.js. Before this chunk existed, HorizontalScroll.js and
 * ScrollPinReveal.js each bundled their own ~190 KB copy.
 *
 * Usage in components: resolve window.gsap / window.ScrollTrigger at Alpine init
 * time (not at module load) - this chunk is loaded async and may execute later.
 */
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
